"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
var React = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var styled_1 = require("../../styled");
var NotificationBarWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var ContentLeftWrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var NotificationText = styled_1.default.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 8px;\n  margin-right: 8px;\n"], ["\n  margin-left: 8px;\n  margin-right: 8px;\n"])));
var IconRightWrapper = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-self: flex-end;\n"], ["\n  align-self: flex-end;\n"])));
var EnvirioNotificationBar = function (_a) {
    var children = _a.children, className = _a.className, content = _a.content, icon = _a.icon, text = _a.text;
    return (React.createElement(NotificationBarWrapper, { className: className },
        React.createElement(ContentLeftWrapper, null,
            React.createElement("div", null,
                React.createElement(semantic_ui_react_1.Icon, { name: icon })),
            React.createElement(NotificationText, null, text),
            content ? React.createElement(NotificationText, null, content) : children),
        React.createElement("div", null,
            React.createElement(IconRightWrapper, null,
                React.createElement(semantic_ui_react_1.Icon, { name: "close", style: { cursor: 'pointer' } })))));
};
var BaseNotificationBar = styled_1.default(EnvirioNotificationBar)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  min-height: 40px;\n  border-radius: 10px;\n  padding: 10px;\n"], ["\n  min-height: 40px;\n  border-radius: 10px;\n  padding: 10px;\n"])));
exports.Notification = styled_1.default(BaseNotificationBar)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n"], ["\n  color: ", ";\n  background-color: ",
    ";\n"])), function (props) { return props.theme.colors.white; }, function (props) {
    return props.variant === 'neutral'
        ? props.theme.colors.black
        : props.theme.colors[props.variant];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map